import GenericPropertiesControl from './GenericPropertiesControl';
import { useBuildingPropertiesStore } from '../../../store/useGeometryPropertiesStore';
const BuildingPropertiesControl = () => {
  const store = useBuildingPropertiesStore();
  
  const properties = [
    { key: 'objectId', label: 'Objekt-ID', value: store.objectId },
    { key: 'objectType', label: 'Gebäudetyp', value: store.objectType },
    { key: 'lod', label: 'LoD', value: store.lod},
    { key: 'muncipalityName', label: 'Gemeinde', value: store.muncipalityName },
    { key: 'buildingFunction', label: 'Funktion', value: store.buildingFunction },
    { key: 'roofShape', label: 'Dachform', value: store.roofShape },
    { key: 'measuredheight', label: 'Gebäudehöhe', value: store.measuredheight },
    { key: 'area', label: 'Grundfläche', value: store.area },
    { key: 'volume', label: 'Volumen', value: store.volume },
  ];

  const handlePropertyUpdate = (key, value) => {
    store.updateProperty(key, value);
  };

  return (
    <GenericPropertiesControl 
      properties={properties}
      onPropertyUpdate={handlePropertyUpdate}
      title="EIGENSCHAFTEN"
    />
  );
};

export default BuildingPropertiesControl;